import React from 'react';
import PropTypes from 'prop-types';
import { getWord } from 'utils/tenant';
import css from './PreferencesSection.scss';
import Icon from 'SF/MaterialIcon';
import classnames from 'classnames';
import Checkbox from '../SF/Checkbox';
import { pressedEnterOrSpace } from 'utils/accessibility';

const InstitutionEmail = ({ allowPreferredEmail, correspondenceTo, goToNotificationsTab, isIE, isStaff, schoolEmail, setValue }) => {
    const handleStaffChecked = (checked) => {
        if (checked) {
            // if the staff user is enabling notifications to institutional email and
            // preferred email notifications has already been set, mark as 'BOTH_MAIL'
            setValue({ correspondenceTo: correspondenceTo === 'PREFERRED_MAIL' ? 'BOTH_MAIL' : 'SCHOOL_MAIL' });
        } else {
            // if the staff user is disabling notifications to institutional email with
            // previous setting to send to both, only send to preferred email
            setValue({ correspondenceTo: correspondenceTo === 'BOTH_MAIL' ? 'PREFERRED_MAIL' : '' });
        }
    };

    const getSupplementalInfo = () => {
        // For a student, notifications are always sent to school email
        // For a tenant with no preferred email allowed, a staff will also have the notifications always sent to school email
        if (!isStaff || !allowPreferredEmail) {
            return (
                <span className={css['profile-sub-text']}>
                    Notifications will always be sent to this email.
                </span>
            );
        }

        return (
            <div className={classnames(css['profile-adv-check'], {[css.error]: correspondenceTo === ''})}>
                <Checkbox ariaLabel=""
                          aria-labelledby="schoolEmailNotification"
                          checked={correspondenceTo === 'SCHOOL_MAIL' || correspondenceTo === 'BOTH_MAIL'}
                          onChange={handleStaffChecked} />
                <span id="schoolEmailNotification" className={css['profile-adv-options'] + ' ' + css['profile-sub-text']}>
                    Send notifications to my {getWord('institutionEmail', true)} address
                    <span className={css['error-message']} aria-hidden={correspondenceTo !== ''}>
                        <br/>
                        <Icon icon="error" aria-hidden="true" />You must have at least one email address selected to receive email notifications
                    </span>
                    <br/>
                    <a href='#'
                       onClick={goToNotificationsTab}
                       onKeyDown={(e) => { if (pressedEnterOrSpace(e)) goToNotificationsTab()} }>
                        Edit Notification Preferences
                    </a>
                </span>
            </div>
        );
    };

    return (
        <div id="school-email-section">
            <label id="schoolEmail">{getWord('institutionEmail')}</label>
            <div className={css['fake-input'] + ' disabled'}>
                    <span aria-labelledby="schoolEmail"
                          className={classnames(css['overflow-fade'], { [css.ie]: isIE })}>
                        {schoolEmail}
                    </span>
                <Icon icon="lock" aria-hidden={true} />
            </div>
            {getSupplementalInfo()}
        </div>
    );
};

InstitutionEmail.propTypes = {
    allowPreferredEmail: PropTypes.bool,
    correspondenceTo: PropTypes.oneOf(['BOTH_MAIL', 'SCHOOL_MAIL', 'PREFERRED_MAIL', '']),
    goToNotificationsTab: PropTypes.func,
    isIE: PropTypes.bool,
    isStaff: PropTypes.bool,
    schoolEmail: PropTypes.string,
    setValue: PropTypes.func
};

export default InstitutionEmail;
